import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
} from "../Components/ui/dialog";

export function VehicleImagePopup({ vehicle, isOpen, onClose }) {
  if (!vehicle) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {vehicle.year} {vehicle.make} {vehicle.model}
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <img
            src={vehicle.image || "/img/cajuu_logo.png"}
            alt={`${vehicle.make} ${vehicle.model}`}
            className="w-full h-auto rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
